import { createContext, useContext } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { FavoritesEnum } from "./FavoritesUtils";

export const useInvalidateAndRefetch = () => {
  const queryClient = useQueryClient();

  const invalidateAndRefetchFavoriteCount = () => {
    queryClient.invalidateQueries({ queryKey: ["FAVORITE_COUNT"] });
  };

  const invalidateAndRefetchCollectionList = () => {
    queryClient.invalidateQueries({ queryKey: [FavoritesEnum.full_list] });
  };

  return {
    invalidateAndRefetchFavoriteCount,
    invalidateAndRefetchCollectionList,
  };
};

const InvalidateContext = createContext({
  invalidateAndRefetchFavoriteCount: () => {},
  invalidateAndRefetchCollectionList: (pageNumber: number) => {
    pageNumber;
  },
});

export const InvalidateProvider = ({ children }) => {
  const {
    invalidateAndRefetchFavoriteCount,
    invalidateAndRefetchCollectionList,
  } = useInvalidateAndRefetch();

  return (
    <InvalidateContext.Provider
      value={{
        invalidateAndRefetchFavoriteCount,
        invalidateAndRefetchCollectionList,
      }}
    >
      {children}
    </InvalidateContext.Provider>
  );
};

export const useInvalidateContext = () => {
  return useContext(InvalidateContext);
};
